import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';

const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    console.log('🔍 Auth0 Redirect - appState:', appState);
    
    // CRITICAL: Capture Stripe payment parameters BEFORE they get stripped
    const currentUrl = new URL(window.location.href);
    const paymentStatus = currentUrl.searchParams.get('payment');
    const sessionId = currentUrl.searchParams.get('session_id');
    const hasPendingBooking = currentUrl.searchParams.get('pendingBooking');
    
    if (paymentStatus === 'success' && sessionId) {
      console.log('💾 CRITICAL: Auth0Provider capturing Stripe sessionId:', sessionId);
      
      // Store in sessionStorage to survive redirects
      const existingPaymentInfo = sessionStorage.getItem('stripePaymentPending');
      let paymentData = existingPaymentInfo ? JSON.parse(existingPaymentInfo) : {};
      paymentData.sessionId = sessionId;
      paymentData.capturedAt = Date.now();
      paymentData.capturedBy = 'Auth0Provider';
      sessionStorage.setItem('stripePaymentPending', JSON.stringify(paymentData));
      
      console.log('✅ SessionId saved by Auth0Provider - will be available after redirect');
      
      // Navigate directly to booking to process payment
      navigate('/booking');
      return;
    }
    
    // Check if this is a new student flow from teacher landing page (FREE CREDIT)
    const teacherFlowData = localStorage.getItem('teacherLandingFlow');
    if (teacherFlowData) {
      const flowData = JSON.parse(teacherFlowData);
      console.log('🎯 NEW STUDENT FLOW: Redirecting to booking with teacher info');
      
      // Store the flow data in sessionStorage for the post-login handler
      sessionStorage.setItem('newStudentFlow', JSON.stringify({
        ...flowData,
        isNewStudent: true,
        needsAutoSetup: true
      }));
      
      // Clear the localStorage data
      localStorage.removeItem('teacherLandingFlow');
      
      // Always go to home first, let public.js handle the rest
      navigate('/');
        return;
      }
      
    // Check if this is an invite code flow from teacher landing page (NO FREE CREDIT)
    if (appState?.referralCode && appState?.teacherSlug && appState?.isNewStudent === false) {
      console.log('🎯 INVITE CODE FLOW: Redirecting to booking with invite code');
      
      // Store the invite code flow data in sessionStorage
      sessionStorage.setItem('inviteCodeFlow', JSON.stringify({
        referralCode: appState.referralCode,
        teacherSlug: appState.teacherSlug,
        isNewStudent: false,
        needsAutoSetup: true,
        timestamp: Date.now()
      }));
      
      // Go to home first, let public.js handle the rest
      navigate('/');
        return;
    }
    
    // Default behavior for other flows
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;